import { ReactNode } from "react";
import { SearchResult } from "@iventis/domain-model/model/searchResult";
import { SearchResultType, ResultType } from "../types/types";

export abstract class SearchResultGroupInterface<TResultType extends ResultType> {
    constructor(name: string, type: SearchResultType, icon: ReactNode, onResultClicked: (result: TResultType, displayText: string) => void) {
        this.name = name;
        this.type = type;
        this.icon = icon;
        this.onResultClick = onResultClicked;
    }

    public readonly name: string;

    public readonly type: SearchResultType;

    public readonly icon: ReactNode;

    /** When a result of a search is clicked */
    public onResultClick: (result: TResultType, displayText: string) => void;

    /** Get search results and return them with the type of the result group */
    public abstract getResults(searchString: string): Promise<{ type: SearchResultType; results: SearchResult<TResultType>[] }>;
}
